<template>
    <div class="row">
        <div class="col-sm-12 col-md-12">
            <h5 class="mt-3">
                Crédito parcelado
                <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-primary"
                    @click="showPaymentMethodModal()"
                >
                    <i class="fa fa-plus"></i>
                </a>
            </h5>
            <hr class="mb-3" />
            <div class="ctn">            
                <div class="payment-methods-container">
                    <div v-for="(p, paymentMethodIdx) in selectedPaymentMethods" :key="paymentMethodIdx" class="payment-method">
                        <div class="form-row">
                            <div class="col-sm-6">
                                <h6 class="mt-2">{{p.name}}</h6>
                            </div>
                            <div class="col-sm-6">
                                <div class="d-flex justify-content-center align-items-center" style="height:100%;">
                                    <a href="javascript:void(0);" @click="removePaymentMethod(paymentMethodIdx)">[remover]</a>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <hr />
                            </div>
                        </div>
                        <div class="payment-method-parcels">
                            <div v-for="(s, index) in p.installments" :key="index" class="payment-method-parcel">
                                <div class="form-row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label style="font-weight:bold;">Parcela</label>
                                            <select :class="{'custom-select': true}" :value="s.installmentCount" @change="installmentCountChanged(paymentMethodIdx, index, s.installmentCount, $event)">
                                                <option v-for="(opt, idx) in p.installmentList" :key="idx" :value="opt.value" :disabled="opt.disabled" >
                                                    {{opt.text}}
                                                </option>
                                            </select>                                        
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>MDR %</label>
                                            <vue-numeric
                                                :separator="vueNumericDefaults.separator"
                                                :precision="vueNumericDefaults.decimals"
                                                :output-type="vueNumericDefaults.outputType"
                                                v-model="s.fee.partnerFee"
                                                :class="{'form-control': true}"
                                                :key="index"
                                            />                            
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Plataforma %</label>
                                            <vue-numeric
                                                :separator="vueNumericDefaults.separator"
                                                :precision="vueNumericDefaults.decimals"
                                                :output-type="vueNumericDefaults.outputType"
                                                disabled
                                                v-model="s.fee.platformFee"
                                                :class="{'form-control': true}"
                                                :key="index"
                                            />                            
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Comissão %</label>
                                            <vue-numeric
                                                :separator="vueNumericDefaults.separator"
                                                :precision="vueNumericDefaults.decimals"
                                                :output-type="vueNumericDefaults.outputType"
                                                v-model="s.fee.salesPersonFee"
                                                :class="{'form-control': true}"
                                                :key="index"
                                            />                            
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-7">
                                        <div class="form-group" v-show="!value.usePaymentPeriodInstallment">
                                            <label>Dias disponíveis</label>
                                            <select :class="{'form-control': true}" v-model="s.fee.paymentPeriod">
                                                <option v-for="p in paymentPeriods" :key="p.id" :value="p.days">{{p.name}}</option>
                                            </select>                            
                                        </div>
                                        <div class="form-group" v-show="value.usePaymentPeriodInstallment">
                                            <label>Dias disponíveis</label>
                                            <input
                                                disabled
                                                type="text"
                                                style="font-weight: bold !important;"
                                                class="form-control-plaintext"
                                                value="Conforme parcelas"                              
                                            />
                                        </div>
                                    </div>
                                    <div class="col-sm-5">
                                        <div class="d-flex justify-content-center align-items-center" style="height:100%;">
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-primary"
                                                @click="removeInstallment(paymentMethodIdx, index)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>
            </div>                        
        </div>
        <b-modal
            id="modal-paymentMethod"
            ref="modal"
            title="Adicionar parcela:"
            @hidden="resetModal"
            @ok="handleOk"
            ok-title="Salvar"
            cancel-title="Cancelar"
            v-model="paymentMethodModalVisible">
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <div class="form-row">                    
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label for="paymentMethodLabel">Bandeira</label>
                            <select :class="{'custom-select': true}" v-model="paymentMethodModal.id">
                                <option v-for="(s, index) in paymentMethods" :key="index" :value="s.id">
                                    {{s.name}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>
<script>
import _ from "lodash";
import eventbus from '../../../eventBus';
import paymentMethodService from '../../../services/PaymentMethods/paymentMethodService';
export default {
    name: 'installment-fee-input',
    props: {
        value: {
            type: Object,
            default: {
                source: '',
                installments: [],
                usePaymentPeriodInstallment: false,
            }
        }
    },
    data() {
        return {
            paymentMethodModalVisible: false,
            paymentMethodModal: {
                id: 0
            },
            vueNumericDefaults: {
                decimals: 2,
                separator: '.',
                outputType: 'Number'
            },
            paymentPeriods: [{days: 1, name: 'D1'}, {days: 2, name: 'D2'}, {days: 3, name: 'D3'}, {days: 4, name: 'D4'}, {days: 5, name: 'D5'}, {days: 15, name: 'D15'}, {days: 30, name: 'D30'}],
            paymentMethods: [],
            selectedPaymentMethods: [],
            canBind: false
        }
    },
    computed: {
        
    },
    watch: {
        'value':[
            {
                immediate: true,
                handler: async function() {                                                                            
                    if(this.paymentMethods.length == 0) {
                        await this.bindPaymentMethods();
                    }
                    
                    if(this.value.installments.length == 0)
                        return;
                                        
                    let uniqArray = _.uniqBy(this.value.installments, 'paymentMethodId');
                    let installmentList = this.getInstallmentsList();
                    for(let i = 0; i <= uniqArray.length - 1; i++)
                    {                        
                        let selectedPaymentMethod = _.find(this.paymentMethods, function (p) { return p.id == uniqArray[i].paymentMethodId });
                        selectedPaymentMethod.installments = this.value.installments.filter(function (f) { return f.paymentMethodId == selectedPaymentMethod.id});
                        selectedPaymentMethod.installmentList = [];
                        for (let i = 0; i <= installmentList.length - 1; i++) {
                            let p = _.find(selectedPaymentMethod.installments, function(s) {
                                return s.installmentCount == installmentList[i].value;
                            });
                            selectedPaymentMethod.installmentList.push({
                                value: installmentList[i].value,
                                text: `${installmentList[i].value}x`,
                                disabled: (p && p.installmentCount > 0 ? true : false)
                            });
                        }
                        this.$set(this.selectedPaymentMethods, i, selectedPaymentMethod);                        
                    }
                }
            },
            {
                immediate: false,
                handler: function() {
                    this.$emit('input', this.value)
                }
            }
        ],
        'selectedPaymentMethods': {
            deep: true,
            handler: function() {
                eventbus.$emit(`installment-fee-input:${this.value.source}:refresh`);
            }
        }
    },
    mounted() {
        const self = this;
        eventbus.$on(`installment-fee-input:${this.value.source}:refresh`, function() {            
            self.value.installments = [];
            for(let i = 0; i <= self.selectedPaymentMethods.length - 1; i++) {
                _.forEach(self.selectedPaymentMethods[i].installments, function(installment) {
                    self.value.installments.push(installment);
                });                
            }
            self.$emit('input', self.value);
        });        
    },
    methods: {
        async bindPaymentMethods() {
            const self = this;
            let result = await paymentMethodService.all(1);
            this.paymentMethods = result.data;
            this.paymentMethods.unshift({
                id: 0,
                name: 'Padrão',
                typeId: 1,
                typeName: 'Crédito'
            });
        },
        getInstallmentsList() {
            let installments = [];
            for(let i = 1; i <= 18; i++)
            {
                installments.push({
                    value: i,
                    text: `${i}x`,
                    disabled: false
                });
            }
            return installments;
        },
        showPaymentMethodModal() {
            this.paymentMethodModalVisible = true;
        },
        addInstallment(currentPaymentMethod) {
            
            let selected = 0;                    

            if (currentPaymentMethod.installments.length > 0) 
            {
                for (let i = 0; i <= currentPaymentMethod.installmentList.length - 1; i++) {
                    let p = _.find(currentPaymentMethod.installments, function(s) {
                        return s.installmentCount == currentPaymentMethod.installmentList[i].value;
                    });
                    if (p && p.installmentCount > 0) {
                        currentPaymentMethod.installmentList[i].disabled = true;
                    }
                }
                let selectedItems = _.find(currentPaymentMethod.installmentList, ["disabled", false]);
                if (!selectedItems) return;
                selected = selectedItems.value;
                selectedItems.disabled = true;
            } 
            else
            {
                selected = currentPaymentMethod.installmentList[0].value;
            }
            let feeDefinition = {
                partnerFee: 0,
                salesPersonFee: 0,
                platformFee: 0,
                partnerTax: 0,
                paymentPeriod: 1
            }

            currentPaymentMethod.installments.push({        
                installmentCount: selected,
                fee: feeDefinition,
                source: this.value.source,
                paymentMethodId: currentPaymentMethod.id
            });            
            currentPaymentMethod.installments = _.orderBy(currentPaymentMethod.installments, ['installmentCount']);
        },
        removeInstallment(paymentMethodIdx, index) {
            let selected = this.selectedPaymentMethods[paymentMethodIdx];
            selected.installments.splice(index, 1);
            if(selected.installments.length == 0) {
                this.removePaymentMethod(paymentMethodIdx);
                return;
            }
            this.$set(this.selectedPaymentMethods, paymentMethodIdx, selected)            
        },
        removePaymentMethod(index) {
            this.selectedPaymentMethods.splice(index, 1);
        },
        resetModal(){},
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()
            //this.salesmanModel.errorMessage = ''
            //this.salesmanModel.hasError = false
            // Trigger submit handler
            this.handleSubmit()
        },
        handleSubmit() {
            const self = this;
            let idx = this.selectedPaymentMethods.findIndex(function(el) { return el.id == self.paymentMethodModal.id });
            let currentPaymentMethod = idx < 0 ? {} : this.selectedPaymentMethods[idx];
            let p = this.paymentMethods.find(function(el) { return el.id == self.paymentMethodModal.id });
            if(idx < 0)
            {
                currentPaymentMethod = {
                    id: this.paymentMethodModal.id,
                    name: p.name,
                    installments: [],
                    installmentList: self.getInstallmentsList()
                }
                this.selectedPaymentMethods.push(currentPaymentMethod);
                idx = this.selectedPaymentMethods.length - 1;
            }
            this.addInstallment(currentPaymentMethod);
            this.$set(this.selectedPaymentMethods, idx, currentPaymentMethod);            
            this.selectedPaymentMethods = _.orderBy(this.selectedPaymentMethods, ['id']);
            self.$nextTick(() => {
                self.$refs.modal.hide()
            })
        },
        installmentCountChanged(paymentMethodIdx, installmentIdx, installmentCount, event) {
            let i = _.findIndex(this.selectedPaymentMethods[paymentMethodIdx].installmentList, function(s) {
                return s.value == installmentCount;
            });
            let current = this.selectedPaymentMethods[paymentMethodIdx];
            current.installmentList[i].disabled = false;
            this.$set(this.selectedPaymentMethods, paymentMethodIdx, current);

            i = _.findIndex(this.selectedPaymentMethods[paymentMethodIdx].installmentList, function(s) {
                return s.value == event.target.value;
            });
            current = this.selectedPaymentMethods[paymentMethodIdx];
            current.installmentList[i].disabled = true;
            current.installments[installmentIdx].installmentCount = event.target.value;
            this.$set(this.selectedPaymentMethods, paymentMethodIdx, current);
            
        }

    }
}
</script>
<style scoped>
.ctn {
    width:100%;
    height: 500px;
    display: flex;
    flex-direction: row;
}
.payment-methods-container {
    width:100%;
    overflow:auto;
    background-color: rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: stretch;
    position: relative;    
}

.payment-method {
    flex: 0 0 auto;
    max-width:270px;
    padding:8px;
    margin:6px;
    background-color:#fff;
    border: solid 1px #c8ced3;
    align-self: flex-start;
}

.payment-method-parcel {
    background-color:#fff;
    flex-direction: row;
}
</style>